"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.IssueAnalysisComponent = void 0;
var angular = require("angular");
var issue_analysis_chart_1 = require("./issue-analysis.chart");
var basic_chart_component_1 = require("../basic-component/basic-chart.component");
require('./issue-analysis.component.css');
var IssueAnalysisComponent = /** @class */ (function (_super) {
    __extends(IssueAnalysisComponent, _super);
    function IssueAnalysisComponent($scope, $timeout) {
        var _this = 
        // This constructor is necessary for inject scope and timeout.
        _super.call(this, $scope, $timeout, 'IssueAnalysis') || this;
        var ctrl = _this;
        _this.orientation = 'vertical';
        _this.chartInverted = true;
        $scope.$on('command:ISSUE_ANALYSIS', function (event, args) {
            ctrl.selectedX = 0;
            ctrl.selectedY = 0;
            ctrl.xAxisData = [];
            ctrl.yAxisData = [];
            ctrl.dataGot = args.config.data.data[0];
            ctrl.xAxisData = { data: ctrl.dataGot.headerMap[0]['data_x'], selected: ctrl.selectedX };
            ctrl.yAxisData = { data: ctrl.dataGot.headerMap[0]['data_y'], selected: ctrl.selectedY };
            ctrl.initComponent(event, args);
            ctrl.menu = ctrl.getMenu();
        });
        return _this;
    }
    IssueAnalysisComponent.prototype.axisChanged = function () {
        var ctrl = this;
        ctrl.xAxisData = { data: ctrl.dataGot.headerMap[0]['data_x'], selected: ctrl.selectedX };
        ctrl.yAxisData = { data: ctrl.dataGot.headerMap[0]['data_y'], selected: ctrl.selectedY };
        var chartOptions = this.getChartOptions(this.graph, this.options);
        this.makeChart(chartOptions);
    };
    IssueAnalysisComponent.prototype.getChartOptions = function (graph, options) {
        this.graph = graph;
        this.options = options;
        options['chartInverted'] = this.chartInverted;
        if (!graph || graph.length == 0) {
            this.tableData = [];
        }
        var xKey = this.dataGot.headerMap[0]['data_x'][this.selectedX]['key'];
        var xDisplay = this.dataGot.headerMap[0]['data_x'][this.selectedX]['display'];
        var yKey = this.dataGot.headerMap[0]['data_y'][this.selectedY]['key'];
        var yDisplay = this.dataGot.headerMap[0]['data_y'][this.selectedY]['display'];
        this.tableData = __assign(__assign({}, this.tableData), { inputData: __assign(__assign({}, this.tableData.inputData), { mainRows: (0, issue_analysis_chart_1.filterZeroImpactIgnorance)(this.tableData.inputData.mainRows).map(function (obj) {
                    obj.name = obj.pLabel;
                    return obj;
                }), headerMap: [{ "key": xKey, "text": xDisplay },
                    { "key": yKey, "text": yDisplay }] }) });
        return (0, issue_analysis_chart_1.getChartOptions)(graph, options, this.xAxisData, this.yAxisData);
    };
    IssueAnalysisComponent.prototype.makeChart = function (chartOptions) {
        var ctrl = this;
        var highChartGot = (0, issue_analysis_chart_1.makeChartGraph)(chartOptions.series, ctrl.xAxisData, ctrl.yAxisData, chartOptions);
        (0, basic_chart_component_1.handleResponsiveNess)(highChartGot);
    };
    IssueAnalysisComponent.prototype.rotateChart = function () {
        this.orientation = this.orientation === 'horizontal' ? 'vertical' : 'horizontal';
        this.chartInverted = this.orientation !== 'horizontal';
        this.options['chartInverted'] = this.chartInverted;
        var chartOptions = this.getChartOptions(this.graph, this.options);
        this.makeChart(chartOptions);
    };
    IssueAnalysisComponent = __decorate([
        (0, basic_chart_component_1.Component)({
            bindings: {
                menu: '='
            },
            template: require("./issue-analysis.component.html")
        }),
        __metadata("design:paramtypes", [Object, Object])
    ], IssueAnalysisComponent);
    return IssueAnalysisComponent;
}(basic_chart_component_1.BasicChartComponent));
exports.IssueAnalysisComponent = IssueAnalysisComponent;
angular.module('smartorg.r6.acts.issueAnalysis', []).component('issueAnalysis', IssueAnalysisComponent);
module.exports = 'smartorg.r6.acts.issueAnalysis';
//# sourceMappingURL=issue-analysis.component.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/issue-analysis/issue-analysis.component.js